import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { API_URL } from "../../services/APIRoute";
import { apiResponse } from "../../services/APIResponse";
import { useDispatch } from "react-redux";
import {
  organizations,
  userInfo,
  userRoleRight,
  userToken,
} from "../../services/ReduxTookit/UserInfoSlice";
import HashLoader from "react-spinners/HashLoader";
import logo from "../../assets/images/loginlogo.svg";

const GitVerify = () => {
  const { code } = useParams();
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [LoadingGit, setLoadingGit] = useState(true);

  const fetchUserProfile = async (code, userId) => {
    try {
      setLoadingGit(true);
      const formData = new FormData();
      formData.append("code", code);
      formData.append("userid", userId);
      const resData = await axios.post(
        API_URL.BASEURL + API_URL.LOGIN_GITHUB_WITH_USER,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            requesturl: window.location.origin,
          },
        }
      );

      let response = apiResponse(true, resData?.data, setLoadingGit);
      if (response?.isValidate) {
        // dispatch(userToken(response?.data?.data?.dataList1[0]?.accesstoken));
        // dispatch(userInfo(response?.data?.data?.dataList1[0]));
        // dispatch(userRoleRight(response?.data?.data?.dataList2));
        dispatch(
          userToken(response?.payload?.data?.data?.dataList1[0]?.accesstoken)
        );
        if (response?.payload?.data?.data?.dataList1) {
          dispatch(userInfo(response?.payload?.data?.data?.dataList1[0]));
        }
        if (response?.payload?.data?.data?.dataList2) {
          dispatch(userRoleRight(response?.payload?.data?.data?.dataList2));
        }
        if (response?.payload?.data?.data?.dataList3) {
          dispatch(organizations(response?.payload?.data?.data?.dataList3));
        }
      }
      if (!response?.isValidate) {
        navigate("/");
      }
    } catch (error) {
      setLoadingGit(false);
    }
  };

  useEffect(() => {
    if (code) {
      const finalPath = window.location.origin + "/git_verify/";
      const githubAuthUrl = `https://github.com/login/oauth/authorize?state=${code}&client_id=${process.env.REACT_APP_GIT_CLIENT_KEY}&redirect_uri=${finalPath}`;
      window.location.href = githubAuthUrl;
    }
  }, [code]);

  useEffect(() => {
    const encryptedCode_Code = searchParams.get("code");
    const encryptedState_UserId = searchParams.get("state");
    if (encryptedCode_Code && encryptedState_UserId) {
      fetchUserProfile(encryptedCode_Code, encryptedState_UserId);
    }
  }, [searchParams]);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh",
    width: "100vw",
    textAlign: "center",
    color: "#4a4a4a",
    fontFamily: "Arial, sans-serif",
  };

  const textStyle = {
    marginTop: "20px",
    fontSize: "18px",
    animation: "fade 1.5s ease-in-out infinite",
  };

  return (
    LoadingGit && (
      <>
        <div className="login-page-main-wrapper">
          <div className="w-100 text-start loginlogo-wrapper">
            <img src={logo} alt="logo" className="loginlogo" />
          </div>

          <div style={containerStyle}>
            <HashLoader
              color="#2b8dc8"
              loading={LoadingGit}
              size={100}
              aria-label="Loading Spinner"
              data-testid="loader"
              css={{
                "@media (max-width: 600px)": {
                  size: 100,
                },
              }}
            />
            <p style={textStyle}>Signing-in, please wait...</p>
          </div>
        </div>
      </>
    )
  );
};

export default GitVerify;
